/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Stepper } from "react-form-stepper";
import { Link } from "react-router-dom";
import { api_url, defaultHeaders } from "../../Constants/web_services";
import { useSelector } from "react-redux";
import { selectUserData } from "../../Redux/UserSlice";
import confirmed from '../../Assets/images/confirmed.gif'
import moment from "moment";
import Loading from "../SearchList/Loading";
import No_Order from "./UserPanelParts/No_Order";
import OrderReviewForm from "./OrderReviewForm";
import NoOrderFound from "./UserPanelParts/NoOrderFound";
import '../../Assets/css/pay.css'
// import orderCancel from "../../Assets/images/order-cancel.png";
// import arrow from "../../Assets/images/arrow-curve.png";

const stepNumber = {
  "Order Placed": 0,
  "Payment Confirmed": 1,
  "Project Started": 2,
  "Mid Progress": 3,
  "Approval Finalize": 4,
  "Review": 5,
  "Completed": 6,
  null: 7
};
const OrderScreen = () => {
  // const dispatch = useDispatch();
  // const isSignedIn = useSelector(selectSignedIn);
  const userData = useSelector(selectUserData);

  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [timeLeft, setTimeLeft] = ('')
  const [days, setdays] = useState();
  const [hours, setHours] = useState('');
  const [minutes, setMin] = useState('')
  const [sec, setSec] = useState('');

  // const [rating, setRating] = useState("");




  // useEffect(() => {
  //   // Set a timer to hide the loading component after 3000 milliseconds (3 seconds)
  //   const timer = setTimeout(() => {
  //     setIsLoading(false);
  //   }, 5000);

  //   // Clean up the timer when the component is unmounted or if you navigate away
  //   return () => clearTimeout(timer);
  // }, []);



  useEffect(() => {
    const fetchOrders = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem('token'); // Retrieve the token from local storage or another storage method

        const response = await fetch(`${api_url}/api/user-order`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // Include the token in the Authorization header
          }
        });

        if (!response.ok) {
          throw new Error("Failed to fetch orders");
        }

        const ordersData = await response.json();
        setOrders(ordersData?.data || []);
      } catch (error) {
        console.error("Error fetching orders:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, [api_url, userData.id]);


  const getBackgroundColor = (orderStatus) => {
    switch (orderStatus) {
      case "Order Placed": return "bg-warning";

      case "Payment Confirmed": return "bg-secondary";

      case "Project Started": return "bg-success";

      case "Mid Progress": return "bg-primary";

      case "Approval Finalize": return "bg-info";

      case "Review": return "bg-danger";

      case "Completed": return "bg-dark";

      default: return "bg-light text-black";
    }
  };



  // Call the function initially and whenever order_time_duration changes



  return (
    <>
      <div id="content">
        <div className="content-admin-main my-5">
          <div className="admin-top-area border-0 shadow-bx d-flex flex-wrap justify-content-center m-b30 align-items-center">
            <h2>My User Panel</h2>
          </div>
          <div className="aon-admin-heading">
            <h4 className="s-16 fw-700 text-022279">My Orders</h4>
          </div>
          <div className="card aon-card border-0 shadow">
            <div className="card-body aon-card-body">
              {/* <div className="sf-bd-data-tb-head">
                                <button
                                    className="admin-button"
                                    data-toggle="modal"
                                    data-target="#downloadreport"
                                    type="button"
                                >
                                    <i className="fa fa-plus" />
                                    Download Report
                                </button>
                            </div> */}
              {/* Week Tabs*/}
              <div className="sf-availability-times-tab m-b50">
                <div className="sf-custom-tabs sf-custom-new">
                  {/*Tabs*/}
                  <ul className="nav nav-tabs nav-table-cell">
                    <li>
                      <Link className="active text-decoration-none">
                        Orders
                      </Link>
                    </li>
                    {/* <li>
                                            <a className=" text-decoration-none">
                                                Past
                                            </a>
                                        </li> */}
                  </ul>
                  {/*Tabs Content*/}
                  <div className="tab-content">
                    {/*Upcoming*/}

                    <div id="Upcoming" className="tab-pane active">
                      <div className="sf-tabs-content">
                        <div className="sf-bs-data-table ">
                          <div className="table-order ">
                            {isLoading && <Loading />}
                            {orders?.length > 0 ? (
                              orders?.map((order, index) => (
                                <div key={index}>
                                  <input type="hidden" value={order} />
                                  {order?.is_accept !== 10 || order?.order_status !== 'Order Cancel' ?
                                    (<>
                                      <table
                                        key={index}
                                        className={`table table-bordered border-0  ${index % 2 === 0 ? "table-striped" : ""
                                          }`}
                                        style={{ width: "100%" }}
                                      >
                                        <tbody>
                                          <tr>
                                            <th style={{ maxWidth: "75px" }}>
                                              Order no
                                            </th>
                                            <th>Order Info</th>
                                            {/* <th>Order status</th> */}
                                            <th>Total Payment</th>
                                            <th>Action</th>
                                          </tr>

                                          <tr style={{ maxWidth: "65px" }}>
                                            <td className="text-center text-bold ">
                                              <strong style={{ fontSize: "20px" }}>
                                                {index + 1}
                                              </strong>
                                            </td>
                                            <td className="ps-4">
                                              <div className="sf-booking-info-col">
                                                <ul className="customer-info ps-0">
                                                  <li className="fw-600" >
                                                    <strong className="fw-700">
                                                      <i className="fa fab fa-orcid icon-container" />{" "}
                                                      Order No #
                                                    </strong>{" "}
                                                    {order?.order_no
                                                    }

                                                  </li>
                                                </ul>
                                                <div className="sf-booking-customer">
                                                  <ul className="customer-info ps-0">
                                                    <li>
                                                      <strong className="fw-700">
                                                        <i className="fa fas fa-building icon-container" />{" "}
                                                        Company
                                                      </strong>{" "}
                                                      <Link to={`/profile/${order?.company?.id}`} className="badge badge-pill badge-primary text-capitalize">
                                                        {order?.company?.name}
                                                      </Link>

                                                    </li>
                                                    <li>
                                                      <strong className="fw-700 ">
                                                        <i className="fa fas fa-chart-bar icon-container" />{" "}
                                                        Order status
                                                      </strong>
                                                      <div
                                                        className={`badge badge-pill ${order?.order_status ? getBackgroundColor(order?.order_status) : "none-color"
                                                          }`}
                                                      >
                                                        {order?.order_status ===
                                                          "Order Placed"
                                                          ? "Waiting for Payment"
                                                          : order?.order_status ===
                                                            "Payment Confirmed"
                                                            ? "Now work is started"
                                                            : order?.order_status ===
                                                              "Project Started"
                                                              ? "Work on its mid process"
                                                              : order?.order_status ===
                                                                "Mid Progress"
                                                                ? "Needs your approval"
                                                                : order?.order_status ===
                                                                  "Approval Finalize"
                                                                  ? "Now have to Review"
                                                                  : order?.order_status ===
                                                                    "Review"
                                                                    ? "Review to finalize & pay"
                                                                    : order?.order_status ===
                                                                      "Completed"
                                                                      ? "Order complete, payment sent"
                                                                      : order?.order_status ===
                                                                        0 ||
                                                                        order?.order_status ===
                                                                        null
                                                                        ? "no status available"
                                                                        : ""}
                                                      </div>
                                                    </li>
                                                    <li>
                                                      <strong className="fw-700">
                                                        <i className="fa fas fa-arrows-up-to-line icon-container" />{" "}
                                                        Last Update
                                                      </strong>{" "}
                                                      {moment(
                                                        order?.latest_update
                                                      ).format(
                                                        "Do MMM YYYY"
                                                      )}
                                                    </li>
                                                    <li>
                                                      <strong className="fw-700">
                                                        <i className="fa fas fa-calendar-day icon-container" />{" "}
                                                        Order Placed On
                                                      </strong>{" "}
                                                      {moment(
                                                        order?.created_at
                                                      ).format(
                                                        "Do MMM YYYY"
                                                      )}
                                                    </li>
                                                    <li className={`fw-700 ${order?.last_time_duration === null ? 'text-danger' :
                                                      moment().isSame(order?.order_time_duration) ? 'text-warning' :
                                                        moment().isAfter(order?.order_time_duration) ? 'text-danger' : 'text-success'}`}>

                                                      <strong className="fw-700">
                                                        <i className="fa fas fa-timeline icon-container " /> Delivery Date
                                                      </strong>{" "}
                                                      {order?.order_time_duration !== null
                                                        ? moment(order?.last_time_duration).format("Do MMM YYYY")
                                                        : "Duration less order or may be time is not decided"}
                                                    </li>
                                                    <li className={`fw-700 ${order?.last_time_duration === null ? 'text-danger' :
                                                      moment().isSame(order?.order_time_duration) ? 'text-warning' :
                                                        moment().isAfter(order?.order_time_duration) ? 'text-danger' : 'text-success'}`}>

                                                      <strong className="fw-700">
                                                        <i className="fa fas fa-hourglass icon-container " /> Remaing Time
                                                      </strong>{" "}
                                                      {/* <div className="bg-danger radius-sm">


                                                        <div className="text-white text-center fw-700">
                                                          <h2 className='mb-3'>{timeLeft?.days} Days </h2>
                                                          <div className="row justify-content-between mt-1">
                                                            <div className="col-sm-4 ">
                                                              <p className='m-0'>{timeLeft?.hours}</p>
                                                              <p>Hours</p>
                                                            </div>
                                                            <div className="col-sm-4 ">
                                                              <p className='m-0'> {timeLeft?.minutes}</p>
                                                              <p>Minutes</p>
                                                            </div>
                                                            <div className="col-sm-4 ">
                                                              <p className='m-0'>{timeLeft?.seconds}</p>
                                                              <p>Seconds</p>
                                                            </div>

                                                          </div>
                                                        </div>
                                                      </div> */}

                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </td>

                                            <td className="text-center">

                                              <div className="inner">
                                                <h3>
                                                  <span
                                                    title=""
                                                  >

                                                    {!["Completed", "Order Cancel", "Payment Confirmed"].includes(order?.order_status) ? (
                                                      <div className="frame">
                                                        <button className="custom-btn btn-12">
                                                          <span className="fw-600">
                                                            {order?.payment === null ? 0 : order?.payment} $
                                                            <img className="payment-verified ml-1 mb-2" src={confirmed} style={{ width: '30px' }} alt="" />
                                                          </span>
                                                          <span>Payment verified</span>
                                                        </button>
                                                      </div>
                                                    ) : (
                                                      <>
                                                        <p className="fw-600 ">
                                                          {order?.payment === null ? 0 : order?.payment} $

                                                        </p>
                                                        <p className="font-size-12 waviy">Payment not confirmed</p>
                                                      </>

                                                    )}





                                                  </span>

                                                </h3>
                                              </div>
                                            </td>
                                            <td className="text-center">
                                              <Link
                                                to={`/user-profile/${userData?.id}/order-details/${order?.id}`}

                                                className="admin-button btn-sm viewBookings me-1"
                                                title="See Order Details"
                                              >
                                                <i className="fa fa-eye" />
                                              </Link>
                                              <Link
                                                to={`/user-profile/${userData?.id}/order-chat/${order?.id}`}

                                                className="admin-button btn-sm viewBookings me-1"
                                                title="See Order Details"
                                              >
                                                <i className="fa fa-wechat" />
                                              </Link>




                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="text-center" colSpan="5">
                                              <Stepper
                                                steps={[
                                                  { label: "Payment Confirmed" },
                                                  { label: "Project Started" },
                                                  { label: "Mid process" },
                                                  { label: "Approval & Finalize" },
                                                  { label: "Review" },
                                                  { label: "Completed" },
                                                ]}
                                                styleConfig={{
                                                  activeBgColor:
                                                    "rgba(255, 193, 38 , 0.6)",
                                                  activeTextColor: "#fff",
                                                  inactiveBgColor: "#fff",
                                                  inactiveTextColor: "#999",
                                                  completedBgColor: "#ffb600",
                                                  completedTextColor: "#fff",
                                                  size: "2em",
                                                }}
                                                activeStep={
                                                  stepNumber[order?.order_status]
                                                }
                                              />
                                              {
                                                order?.order_status === "Review" ||
                                                  order?.order_status === 5 ? (
                                                  <>

                                                    <OrderReviewForm order={order} key={index} />
                                                  </>

                                                ) : <></>
                                              }
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table >
                                      <div>
                                        <hr className="text-danger border-2" />
                                        <hr className="text- border-2" />
                                      </div>
                                    </>)
                                    :

                                    <>
                                      <No_Order />
                                    </>
                                  }

                                </div>
                              ))
                            ) : (

                              <>
                                <NoOrderFound />
                              </>
                            )}
                          </div>
                        </div >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default OrderScreen;
